import axios from "axios";

const API = process.env.REACT_APP_API_BASE || "https://vision.viewmax.net/api";

const authAxios = axios.create({ baseURL: API });

// Attach token to each request (prefer JWT; fallback to DRF token)
authAxios.interceptors.request.use((config) => {
  //const jwt = localStorage.getItem("accessToken");   // JWT
  const jwt = localStorage.getItem("access"); 
  const drf = localStorage.getItem("authToken");     // DRF token (legacy)
  if (jwt) {
    config.headers.Authorization = `Bearer ${jwt}`;
  } else if (drf) {
    config.headers.Authorization = `Token ${drf}`;
  }
  return config;
});

// Global 401 handler
// Global 401 handler
authAxios.interceptors.response.use(
  (res) => res,
  (err) => {
    const isLoginPage = window.location.pathname === "/";
    const hasToken = !!localStorage.getItem("access");

    if (err.response?.status === 401 && hasToken && !isLoginPage) {
      console.warn("🔐 Token expired or invalid. Redirecting to login.");
      localStorage.removeItem("access");
      localStorage.removeItem("authToken");
      localStorage.removeItem("userName");
      localStorage.removeItem("userEmail");
      window.location.href = "/";
    }

    return Promise.reject(err);
  }
);

export default authAxios;

